import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { useGetGroupsListQuery } from '../store/Api';


interface Props {
  formProps?: FormItemProps;
}

export function SelectGroupe({ formProps }: Props) {
  const { data: groups, isLoading } = useGetGroupsListQuery();

  if (isLoading) {
    return <LoadingOutlined />;
  }

  if (groups === undefined) {
    return;
  }

  return (
    <Form.Item
      label={t('form-items.select.groupe')}
      name={'groupeId'}
      {...formProps}
    >
      <Select
        optionFilterProp="label"
        showSearch
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
        options={groups.items.map((groupe) => ({
          label: groupe.name,
          value: groupe.id
        }))}
      />
    </Form.Item>
  );
}
